import { IInmateActivity, IInmateActivitySummary } from '../models/inmate_activity';
import { IApiService, IPaginatedResponse } from '../services/api_service';

export const inmateAccount = (siteApi: IApiService, centralApi: IApiService) => ({
  activity: {
    index: (params): Promise<IPaginatedResponse<IInmateActivity>> => {
      return centralApi.get('/inmate-account/activity', { params });
    },
    post: (data) => {
      return siteApi.post('/inmate-account/activity', data);
    }
  },
  audioVideoSummary: (params = {}): Promise<IPaginatedResponse<IInmateActivitySummary>> => {
    return centralApi.get('/inmate-account/audio-video/summary', { params });
  },
  summary: (params = {}): Promise<IPaginatedResponse<IInmateActivitySummary>> => {
    return centralApi.get('/inmate-account/summary', { params });
  },
  commissaryTransfer: {
    index: function (params) {
      return centralApi.get('/inmate-account/commissary-transfer', { params });
    },
    post: function (data) {
      return centralApi.post('/inmate-account/commissary-transfer', data);
    },
    delete: function (id, description) {
      return centralApi.delete(`/inmate-account/commissary-transfer/${id}`, { params: { description } });
    }
  }
});
